import { render } from "./CustomSwitch.vue?vue&type=template&id=6ba2c870"
import script from "./CustomSwitch.vue?vue&type=script&lang=ts"
export * from "./CustomSwitch.vue?vue&type=script&lang=ts"
script.render = render

export default script